import script from "./MeetingQuestionReviewDr.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingQuestionReviewDr.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingQuestionReviewDr.vue?vue&type=style&index=0&id=2039846d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2039846d"]])

export default __exports__